import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'no-margin-form-field',
  templateUrl: './no-margin-form-field.component.html',
})
export class NoMarginFormFieldWrapperComponent extends FieldWrapper {
  override defaultOptions = {
    props: {
      localize: true,
    },
  };
}